<template>
  <div @mouseover="hover = true" @mouseleave="hover = false" class="copyable" >
    <div class="copyarea">
      <!-- @slot Use this slot for the text send via props -->
      <slot></slot>
    </div>
    <!-- Click this icon to copy the text -->
    <v-btn :style="style" class="copy-btn" @click="copy" x-small icon><v-icon style="opacity:.7" size="12">mdi-content-copy</v-icon></v-btn>
  </div>
</template>

<script>
/**
   * @displayName Copyable
   */
export default {
  components: {
  },
  computed : {
    /**
      * Gets called when the user clicks on the text
    */
    style(){
      return { visibility : this.hover ? 'visible' : 'hidden'};
    },
  },
  data()
  {
    return {
        hover: false
    }
  },
  methods : { 
    /**
      * Function to copy the text
    */
    copy()
    {
      var str = this.$el.querySelector(".copyarea").innerText;

      const el = document.createElement('textarea');
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.latestCopy = str;
      this.snackbar = true;
    }
  }
}
</script>

<style scoped lang="scss">
.copyable
{
  display:flex;
  width:100%;
  justify-content: space-between;

  cursor:copy;

  .copy-btn {
    // display:none;
    position:relative;
    // left:-10px;
  }
  .copy-btn-area
  {
    width:0px;
  }
}
</style>
